import { ReportData } from 'src/shared/models/report-data.model';
import { Subject } from 'rxjs';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { ReportDataSet } from 'src/shared/models/report-dataset.model';

export class ReportPageBase {
  data :ReportData = new ReportData();
  filters:ReportFilters = new ReportFilters();
  filterEventsSubject: Subject<void> = new Subject<void>();
  chartData: ReportDataSet[] = [];

  dataUpdated(reportData: ReportData)
  {
    this.data = reportData;
    this.chartData = MiscUtil.getDataFilteredByDataSetName(reportData);
  }

  filterUpdated(filters:ReportFilters)
  {
    this.filters = filters;
    this.filterEventsSubject.next();
  }

  formatValue(value:number, decimalPlaces = 2)
  {
    return MiscUtil.formatGridValue(value, decimalPlaces);
  }

  displayGrid()
  {
    return this.chartData 
    && this.chartData.length > 0 
    && this.chartData[0].data 
    && this.chartData[0].data.length > 0
  }
}
